import {routes as pesareaformacao} from '../pessoal/pesareaformacao'
import {routes as pesDesempenho} from '../pessoal/pesdesempenho'
import {routes as pesAlteracaoDesignacao} from '../pessoal/pesalteracaodesignacao'
import {routes as pescargo} from '../pessoal/pescargo'
import {routes as pescargocomissionado} from '../pessoal/pescargocomissionado'
import {routes as pesIdioma} from '../pessoal/pesidioma'
import {routes as pesFuncao} from '../pessoal/pesfuncao'
import {routes as pesFuncaoEscola} from '../pessoal/pesfuncaoescola'
import {routes as pesHistoricoFuncional} from '../pessoal/peshistoricofuncional'
import {routes as pesLicenca} from '../pessoal/peslicenca'
import {routes as pesProvimento} from '../pessoal/pesprovimento'
import {routes as pesquadro} from '../pessoal/pesquadro'
import {routes as relatorioAfastamento} from '../pessoal/relatorioafastamento'
import {routes as pesServidor} from '../pessoal/pesservidor'
import {routes as pesTipoDesligamento} from '../pessoal/pestipodesligamento'
import {routes as PesTipoMovimentacao} from '../pessoal/pestipomovimentacao'
import {routes as pesTipoOcorrencia} from '../pessoal/pestipoocorrencia'
import {routes as PesTipoBeneficio} from '../pessoal/pestipobeneficio'
import {routes as pesTipoCurso} from '../pessoal/pestipocurso'
import {routes as PesTipoProventoVariavel} from '../pessoal/pestipoproventovariavel'
import {routes as PesTipoTitulacao} from '../pessoal/pestipotitulacao'
import {routes as pesTitulacao} from '../pessoal/pestitulacao'
import {routes as pesvinculoempregaticio} from '../pessoal/pesvinculoempregaticio'

import { routes as funcionario } from '../pessoal/funcionario'
export default [
  {
    path: '/pessoal',
    name: 'Pessoal',
    description: 'Módulo Pessoal',
    children: [
      ...pesareaformacao,
      ...pesDesempenho,
      ...pesAlteracaoDesignacao,
      ...pescargo,
      ...pescargocomissionado,
      ...pesIdioma,
      ...pesFuncao,
      ...pesFuncaoEscola,
      ...pesHistoricoFuncional,
      ...pesLicenca,
      ...pesProvimento,
      ...pesquadro,
      ...relatorioAfastamento,
      ...pesServidor,
      ...pesTipoDesligamento,
      ...PesTipoMovimentacao,
      ...pesTipoOcorrencia,
      ...pesTipoOcorrencia,
      ...PesTipoBeneficio,
      ...pesTipoCurso,
      ...PesTipoProventoVariavel,
      ...PesTipoTitulacao,
      ...pesTitulacao,
      ...pesvinculoempregaticio, 
      ...funcionario,
    ],
    goesToMenu: true
  }
]
